import React from 'react';
import CURRENCY from 'utils/currency';
import { PAYMENTS } from 'state/payment/type';
import LabeledAmountDisplay from './labeled-amount-display'; // Updated import path

interface IProps {
  row: PAYMENTS.ITransactionSummaryByPaymentType;
}

const TransactionsAccordion = ({ row }: IProps): JSX.Element => {
  const isCashbackAllowedInDisplay = row.method === 'ATM';

  const displayItems = [
    {
      label: 'Gross amount',
      amount: row?.order_amount,
    },
    ...(isCashbackAllowedInDisplay
      ? [
          {
            label: 'Cashback amount',
            amount: row?.cashback_amount,
          },
        ]
      : []),
    {
      label: 'Tip amount',
      amount: row?.tip_amount,
    },
    {
      label: 'Convenience fee',
      amount: row?.provider_fee_amount,
      tooltipText:
        'This fee is applied to all transactions but is not added to the gross receipts above',
      caption: '(Not included in gross receipts)',
      method: row.method,
    },
  ];

  return (
    <>
      <div className="[&>*>*]:px-3 [&>*>*]:py-1 [&>*>*]:w-[21.67%] [&>*>*:first-child]:w-[34.55%]">
        {displayItems.map((item, index) => (
          <div
            key={index}
            className="flex font-normal text-sm leading-5 text-gray-blue-70"
            style={
              item.label === 'Convenience fee' ? { padding: '4px 0px 0px' } : {}
            }
          >
            <LabeledAmountDisplay
              label={item.label}
              amount={item.amount}
              tooltipText={item.tooltipText}
              caption={item.caption}
              method={item.method}
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default TransactionsAccordion;
